export const createWorker = () => new Worker(new URL(/* webpackChunkName: "game.worker" */ './game.worker.ts', import.meta.url), {
  type: 'module',
});
